<br>
<span>{{'category_to_update'| translation}}: </span>
<br>

<bn-form-field *ngIf="dataCategories">
    <nb-select [(ngModel)]="selectedDataCategory" [placeholder]="'category'| translation">
        <nb-option *ngFor="let category of dataCategories" [value]="category">{{category.title}}</nb-option>
    </nb-select>
</bn-form-field>

<br>
<span>New Icon:</span>
<br>

<nb-form-field *ngIf="iconCategories" class='icon-dropdown'>
    <nb-select [(ngModel)]="selectedCategory" [placeholder]="'category_icon'| translation">
        <nb-option *ngFor="let category of iconCategories" [value]="category">{{category.title}}</nb-option>
    </nb-select>
</nb-form-field>

<nb-form-field class='icon-dropdown'>
    <!-- Placeholder until category is selected  -->
    <nb-select *ngIf="!selectedCategory" [disabled]="!selectedCategory" [(ngModel)]="selectedIcon" [placeholder]="'icon'| translation">
    </nb-select>
    
    <nb-select *ngIf="selectedCategory" [(ngModel)]="selectedIcon" placeholder="Icon"  (selectedChange)="previewCat()">
        <nb-select-label>
            <span [innerHTML]="getIconHtml(selectedIcon)">
            </span>
        </nb-select-label>

        <nb-option *ngFor="let icon of selectedCategory.items" [value]="icon"> <i [ngClass]='icon'></i> </nb-option>
    </nb-select>
</nb-form-field>


<div *ngIf="selectedDataCategory && selectedIcon" class="row">
  <br>
  <span>{{'menu_preview'| translation}}:</span>
  <br>
  <div class="col-md-3">
    <nb-menu [items]="previewList" status="primary" autoCollapse="true"></nb-menu>
  </div>
  <br>
  <div>
    <button nbButton status="primary" (click)="saveCategory()">{{'save'| translation}}</button>
  </div>
</div>

